// /ops/deployments — выкатки и проверки восстановления; с 0.22.2 — раздел «Сервис» «Настроек»,
// адрес прежний. Право — ops.read: администратор клиента и сопровождение. Поиск по версии и коммиту, фильтр и сортировка выкаток — в адресе
// страницы (?q=&backup=&by=&sort=; T158).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { DeploymentsPage } from '../../../features/deployments/DeploymentsPage.tsx';
import { parseDeploymentsSearch } from '../../../features/deployments/deployments-search.ts';
import type { DeploymentsSearch } from '../../../features/deployments/deployments-search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/ops/deployments')({
  validateSearch: parseDeploymentsSearch,
  beforeLoad: requireSection('deployments'),
  staticData: { crumb: 'Выкатки' },
  component: DeploymentsRoute,
});

function DeploymentsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: DeploymentsSearch) =>
      void navigate({ to: '/ops/deployments', search: next, replace: true }),
    [navigate],
  );
  return <DeploymentsPage search={search} onSearchChange={onSearchChange} />;
}
